import { Observable } from 'rxjs/Observable';
import { HttpClient as AngularHttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

@Injectable()
export class HttpClient {

  constructor(public http: AngularHttpClient) { }

  public get<T = any>(url: string, params?: any, toggleLoader?: boolean, headers?: { [prop: string]: string }, options?: { [prop: string]: string }, useOriginalOrg?:boolean): Observable<T> {
    return this.http.get<T>(url, { params: params});
  }

  public delete<T = any>(url: string, params?: any, toggleLoader?: boolean, headers?: { [p: string]: string }, options?: { [prop: string]: string }): any {
    return this.http.delete<T>(url, { params: params});
  }

  public post<T = any>(url, body: any, toggleLoader?: boolean, headers?: { [prop: string]: string }, options?: { [prop: string]: any }): Observable<T> {
    return this.http.post<T>(url, body, options);
  }

  public put<T = any>(url, body, toggleLoader?: boolean, headers?: { [p: string]: string }, params?: { [p: string]: string }, options?: { [prop: string]: string }): Observable<T> {
    return this.http.put<T>(url, { params: params}, options);
  }
}
